import { FetchedContent } from '../types';

export type HttpFetcher = (url: string, init?: RequestInit) => Promise<Response>;

export class HttpContentFetcher {
  constructor(private readonly fetchImpl: HttpFetcher = fetch) {}

  async fetchHead(url: string): Promise<FetchedContent> {
    const response = await this.fetchImpl(url, {
      method: 'HEAD',
      redirect: 'follow',
      headers: {
        'User-Agent': 'Mozilla/5.0 (compatible; HozintMediaResolver/1.0)',
      },
    });

    return {
      url,
      finalUrl: response.url,
      contentType: response.headers.get('content-type'),
      html: null,
      headers: Object.fromEntries(response.headers.entries()),
    };
  }

  async fetchDocument(url: string): Promise<FetchedContent> {
    const response = await this.fetchImpl(url, {
      method: 'GET',
      redirect: 'follow',
      headers: {
        'User-Agent': 'Mozilla/5.0 (compatible; HozintMediaResolver/1.0)',
        Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
      },
    });

    const contentType = response.headers.get('content-type');
    const isHtml = contentType?.includes('text/html');

    return {
      url,
      finalUrl: response.url,
      contentType,
      html: isHtml ? await response.text() : null,
      headers: Object.fromEntries(response.headers.entries()),
    };
  }
}
